// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___v5Dm","type":"styles_type__f0OlJ","choices":"styles_choices__3ZEBc"};